import { AppliedProfile, FormattedAppliedProfile } from "@idw-types/data/applied-profile/applied-profile";
import { AvailableProperty, AxnCompany } from "@idw-types/data/reference-data/axn";
import { convertAppliedProfileTypeToValue } from "@utils/applied-profile-util";
import { formatAppliedProfileProfile } from "./applied-profile-profile-formatter";

export const formatAppliedProfiles = (
    appliedProfiles: Array<AppliedProfile>,
    axnCompanies: Array<AxnCompany>,
    availableProperties: Array<AvailableProperty>,
    shouldPopulateMissingProperties: boolean
): Array<FormattedAppliedProfile> => {
    return appliedProfiles.map(appliedProfile => formatAppliedProfile(
        appliedProfile,
        axnCompanies,
        availableProperties,
        shouldPopulateMissingProperties
    ));
};

export const formatAppliedProfile = (
    appliedProfile: AppliedProfile,
    axnCompanies: Array<AxnCompany>,
    availableProperties: Array<AvailableProperty>,
    shouldPopulateMissingProperties: boolean
): FormattedAppliedProfile => {

    const profile = formatAppliedProfileProfile(
        appliedProfile.profile,
        axnCompanies,
        availableProperties,
        shouldPopulateMissingProperties
    );

    return {
        id: appliedProfile.id,
        nickname: appliedProfile.nickname,
        precedence: appliedProfile.precedence ? parseFloat(appliedProfile.precedence) : 0,
        profile: profile,
        referrerID: appliedProfile.referrerID,
        triggerProfileID: appliedProfile.triggerProfileID,
        type: appliedProfile.type,
        typeValue: convertAppliedProfileTypeToValue(appliedProfile.type)
    };
};
